import { GetResourceGroupResourceOptionsEndpoint } from '@kouto/types';
import useSWR from 'swr';
import { get } from 'utils/axios';
import { z } from 'zod';

type ResourceGroupOptionsResponse = z.infer<
  typeof GetResourceGroupResourceOptionsEndpoint.responseSchema
>;

interface UseResourceGroupOptionsProps {
  experienceIds: string[];
  resourceGroupId?: string;
}

const fetchResourceGroupOptions = async (url: string) => {
  const response = await get<ResourceGroupOptionsResponse>(url);
  return { options: response.items, resources: response.resources };
};

/**
 * What a guest can pick for a pool-backed group, given the resources open for the chosen time, and
 * what they may know about each of those resources.
 */
const useResourceGroupOptions = ({
  experienceIds,
  resourceGroupId,
}: UseResourceGroupOptionsProps) => {
  const url =
    resourceGroupId && experienceIds.length
      ? GetResourceGroupResourceOptionsEndpoint.url({
          resourceGroupId,
          experienceIds: [...experienceIds].sort(),
        })
      : null;

  // A failed lookup must not block booking: the API treats a missing pick as "any resource".
  return useSWR(url, fetchResourceGroupOptions, {
    shouldRetryOnError: false,
  });
};

export default useResourceGroupOptions;
